import { render, staticRenderFns } from "./addMailConfiguration.vue?vue&type=template&id=678e8b0e&"
import script from "./addMailConfiguration.vue?vue&type=script&lang=js&"
export * from "./addMailConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./addMailConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678e8b0e')) {
      api.createRecord('678e8b0e', component.options)
    } else {
      api.reload('678e8b0e', component.options)
    }
    module.hot.accept("./addMailConfiguration.vue?vue&type=template&id=678e8b0e&", function () {
      api.rerender('678e8b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mail/components/addMailConfiguration.vue"
export default component.exports